import styled from 'styled-components';

export const SubscribeFormWrapper = styled.div`
  background: ${props => (props.secondStep ? 'white' : 'var(--blue-primary)')};
  padding: 27px 20px;
  width: 100%;
  margin-top: 40px;
  position: ${props => (props.sticky ? 'sticky' : 'relative')};
  top: ${props => (props.sticky ? '140px' : '0')};
  margin-bottom: ${props => (props.sticky ? '17px' : '27px')};

  .blog-details--subscribe-form-title {
    font-family: 'Sofia Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 25px;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: ${props => (props.secondStep ? 'var(--normal-description-color)' : 'white')};
    margin-bottom: 20px;
  }

  .blog-details--subscribe-form {
    display: block;

    .ant-form-item {
      margin-bottom: 0;
    }

    input {
      width: 100%;
    }

    button {
      width: 100%;
      margin-left: 0;
      padding: 15px 24px;
      font-size: 16px;
      line-height: 110%;
      margin-top: 20px;
    }
  }

  .react-reveal {
    .section-blog-details-legal-info {
      font-family: 'Sofia Pro';
      opacity: 1;
      width: 100%;
      font-size: 13px;
      font-weight: 500;
      line-height: 150%;

      p {
        color: ${props => (props.secondStep ? 'var(--normal-description-color)' : 'white')};
        margin-bottom: 0;
        padding-bottom: 0;
        margin-top: 20px;

        a {
          color: ${props => (props.secondStep ? 'var(--normal-description-color)' : 'white')};
          text-decoration: underline;
        }
      }
    }
  }

  .section-blog-details-form-notification {
    margin-top: ${props => (props.secondStep ? '1em !important' : '0 !important')};
  }

  @media (max-width: 935px) {
    display: ${props => (props.sticky ? 'none' : 'block')};
  }
`;
